// extracted by mini-css-extract-plugin
module.exports = {" _key":"resize-observer/app","root":"app-m__root__61418a2lj42","controls":"app-m__controls__61418a2hkAr","parentContainer":"app-m__parentContainer__61418a2HQoZ"};